const LOWER_SCORE_FOR_PLURALS = false;

export function scoreWordBase(word: string): number {
  const n = word.length;
  if (n === 3 || n === 4) {
    return 1;
  } else if (n === 5) {
    return 2;
  } else if (n === 6) {
    return 3;
  } else if (n === 7) {
    return 5;
  } else if (n >= 8) {
    return 11;
  } else {
    return 0;
  }
}

export function rescoreList(
  word: string,
  wordList: [string, number][]
): number {
  // TODO: remove this logic
  if (LOWER_SCORE_FOR_PLURALS) {
    for (let i = 0; i < wordList.length; i++) {
      const otherWord = wordList[i][0];
      if (word === otherWord + "S") {
        // If we are adding `x + "S"` where `x` is a word we previously added,
        // then we only get 0.5 points.
        return 0.5;
      } else if (word + "S" === otherWord) {
        // If we are adding `x` and we previously added `x + "S"`, we change
        // the score for `x + "S"` to 0.5 and get the full score for `x`. This
        // ensures that `x` and `x + "S"` will always result in the same total
        // score regardless of the order they are added in.
        wordList[i] = [otherWord, 0.5];
        break;
      }
    }
  }

  return scoreWordBase(word);
}
